<template>
  <material-card
    :title="title"
    color="dover-blue">
    <v-form
      ref="form"
      lazy-validation>
      <v-container
        py-0>
        <v-layout
          wrap>
          <v-flex
            xs12
            md12
            lg12>
            <span
              class="caption grey--text font-weight-bold">
              {{ $t('Update licensing file') }}
            </span>
            <hr>
          </v-flex>
          <v-flex
            xs12
            md4
            lg4>
            <v-text-field
              v-model="update.filename"
              :label="`${ $t('Select licensing file to upload to activate new modules') }`"
              :disabled="!enableActions"
              prepend-icon="mdi-attachment"/>
            <input
              ref="updateFile"
              :disabled="!enableActions"
              type="file"
              style="display: none"
              accept="zip"
              @change="onUpdateFilePicked">
          </v-flex>
          <v-flex
            xs12
            md2
            lg2>
            <v-btn
              :disabled="!enableActions"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="doPickRemoteUpdateFile">
              {{ $t('Select .ssr file') }}
            </v-btn>
          </v-flex>
          <v-flex
            xs12
            md4
            lg4
            text-xs-right>
            <v-text-field
              v-model="uploadedFile"
              :label="`${ $t('Uploaded file') }`"
              disabled
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md2
            lg2
            text-xs-right>
            <v-btn
              :disabled="!update.rebootEnabled"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="doConsoleReboot">
              {{ $t('Reboot to apply license') }}
            </v-btn>
          </v-flex>
          <v-flex
            xs12
            md12
            lg12>
            <span>{{ progressBar.label }}</span>
            <MaglinkComponentLoadingBar
              :loading="progressBar.loading"
              :indeterminate="false"
              :max-value="progressBar.maxValue"
              :value="progressBar.currentValue" />
          </v-flex>
          <v-flex
            xs12
            md12
            lg12>
            <span
              class="caption grey--text font-weight-bold">
              {{ $t('Module list') }}
            </span>
            <hr>
          </v-flex>
          <v-flex
            xs12
            md12>
            <v-data-table
              :headers="headers"
              :items="dataSource"
              :no-data-text="`${ Maglink.NoDataMessage(false) }`"
              :no-results-text="`${ Maglink.NoDataMessage(true) }`"
              hide-actions>
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="dover-light-blue-color"
                  v-text="header.text" />
              </template>
              <template
                slot="items"
                slot-scope="{ index, item }">
                <tr
                  :style="{backgroundColor: ((index % 2 === 0) ? '#cfdbfb' : 'transparent' ) }"
                  class="text-xs-left">
                  <td class="text-xs-left">{{ item.id }}</td>
                  <td class="text-xs-left">{{ item.name }}</td>
                  <td class="text-xs-left">{{ item.desc }}</td>
                  <td class="text-xs-center">
                    <img
                      :src="Maglink.GetImageAlarm(item.requireHW ? '0' : '1')"
                      width="15px">
                  </td>
                  <td class="text-xs-center">
                    <img
                      :src="Maglink.GetImageAlarm(item.enabled ? '0' : '1')"
                      width="15px">
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </material-card>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data: () => ({
    update: {
      filename: '',
      filesize: 0,
      rebootEnabled: false
    },
    enableActions: true,
    sourceFunction: '',
    currentOpenCalls: 0,
    progressBar: {
      loading: false,
      maxValue: 10,
      currentValue: 0,
      tickId: 0,
      label: ''
    },
    headers: [],
    dataSource: []
  }),
  computed: {
    uploadedFile () {
      return this.update.filesize
    }
  },
  mounted () {
    this.headers = [
      { sortable: false, text: this.$t('Id'), align: 'left' },
      { sortable: false, text: this.$t('Name'), align: 'left' },
      { sortable: false, text: this.$t('Desc'), align: 'left' },
      { sortable: false, text: this.$t('HW required'), align: 'center' },
      { sortable: false, text: this.$t('Enabled'), align: 'center' }
    ]
    this.getDataSource()
  },
  beforeDestroy () {
    // Perform the teardown procedure for someLeakyProperty.
    // (In this case, effectively nothing)
    clearInterval(this.progressBar.tickId)
  },
  methods: {
    getDataSource () {
    // hard coded values
      this.dataSource = [
        { id: 1, name: 'Base module', desc: 'Alaram, delivery, leakge, autocal, reconciliation...', requireHW: true, enabled: true },
        { id: 2, name: 'Density', desc: 'Density float', requireHW: true, enabled: true },
        { id: 3, name: 'AEF ', desc: 'AeF float', requireHW: true, enabled: false },
        { id: 4, name: 'External I/O', desc: 'Maglink I/O', requireHW: true, enabled: true },
        { id: 5, name: 'ELLD/PLLD', desc: 'Electronic and Pressure line leak detection', requireHW: true, enabled: false },
        { id: 6, name: 'W&M "Lock"', desc: 'W&M lock', requireHW: false, enabled: false },
        { id: 7, name: 'IFSF', desc: 'IFSF (Lon Interface)', requireHW: true, enabled: false }
      ]

    /*
    this.progessBar.loading = true
    this.dataSource = []
    this.Maglink.GetModuleList(this.filters)
      .then(response => {
        this.progessBar.maxValue = response.data.length

        for (var i = 0; i < response.data.length; i++) {
          this.progessBar.currentValue = i
          this.dataSource.push(this.Maglink.ToDisplay(response.data[i], this.systemSettings.levelUnit, this.systemSettings.volumeUnit))
        }
        this.progessBar.loading = false
        this.itemCountLabel = this.$t('Items: {0}', [ this.dataSource.length ])
      })
      .catch(error => {
        this.progessBar.loading = false
        this.snack('error', error.message)
      })
*/
    },
    startTimer () {
      // timer already active
      if (this.progressBar.tickId > 0) return

      this.progressBar.label = this.$t('Awaiting to complete execution...')
      this.progressBar.loading = true
      this.progressBar.currentValue = 0
      this.progressBar.tickId = setInterval(this.progressBarTick, 1000)
    },
    stopTimer () {
      if (this.progressBar.tickId === 0) return

      clearInterval(this.progressBar.tickId)
      this.progressBar.tickId = 0
      this.progressBar.loading = false
      this.progressBar.currentValue = 0
      this.progressBar.label = ''
    },
    progressBarTick () {
      if (this.progressBar.currentValue >= this.progressBar.maxValue) this.progressBar.currentValue = 0

      this.progressBar.currentValue += 1
      this.progressBar.label = this.$t('Awaiting to complete execution {0}...{1}', [ this.progressBar.currentValue, this.sourceFunction ])
    },
    doPickRemoteUpdateFile () {
      this.$refs.updateFile.click()
    },
    onUpdateFilePicked (e) {
      this.working(true, 'Uploading license file .ssr in progress...')

      const files = e.target.files
      if (files.length === 0) return

      if (files[0] !== undefined) {
        this.update.filename = files[0].name

        // if you want to upload multiple files at once loop
        // through the array of files
        let zipFile = new FormData()
        zipFile.append('file', files[0])

        this.Maglink.ConsoleUpdate(zipFile)
          .then(response => {
            this.working(false, '')

            let resp = response.data // {result, msg} result=0 --> ok; result != 0 --> "error msg"

            if (resp.result === '0') {
              this.update.filesize = this.Maglink.RoundFormat(resp.filesize / 1024 / 1024, 2) + 'MB'
              this.update.filesize = this.update.filename + '     (' + this.update.filesize + ')'
              this.update.rebootEnabled = true
              this.snack('success', this.$t(resp.msg))
            } else {
              this.snack('error', this.$t(resp.msg))
            }
          })
          .catch(error => {
            this.working(false, '')
            this.snack('error', error.message)
          })
      } else {
        this.working(false, '')
      }
    },
    doConsoleReboot () {
      this.Maglink.ConsoleReboot({})
        .then(response => {
          this.snack('success', this.$t('Rebooting...'))
        })
        .catch(error => (this.snack('error', error.message)))
    },
    working (active, source) {
      // to manage concurrent calls
      if (active) {
        this.currentOpenCalls += 1
      } else {
        this.currentOpenCalls -= 1
      }

      if (this.currentOpenCalls > 0) {
        this.manageGUI(false)
        this.sourceFunction = active ? this.$t(source) : ''
        this.startTimer(source)
      } else {
        this.manageGUI(true)
        this.currentOpenCalls = 0
        this.stopTimer()
      }
    },
    manageGUI (flag) {
      this.enableActions = flag
    },
    snack (color, message) {
      let msg = this.title + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message: msg, show: true })
    }
  }
}
</script>
